import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// import { LayoutRoutingModule } from './layout-routing.module';
import { SharedModule } from '../../../shared/shared.module';
import { LayoutService } from './layout.service';

import { TopbarComponent } from './topbar/topbar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { ContainerComponent } from './container/container.component';
import { FooterComponent } from './footer/footer.component';
import { LayoutComponent } from './layouts/normal/layout.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    LayoutComponent,
    TopbarComponent,
    NavbarComponent,
    ContainerComponent,
    FooterComponent
  ],
  exports: [
    LayoutComponent,
    TopbarComponent,
    NavbarComponent,
    ContainerComponent,
    FooterComponent,
  ],
  providers: [
    LayoutService
  ]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// ./client/app/core/layout/secure/layout.module.ts